var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFleeceSweatpant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1873 11.4229C31.1019 8.65115 30.4443 8.29988 30.4443 8.29988L29.4273 7.50488H29.1123H19.0283H18.7063L17.6963 8.29988L16.499 9.49988L15.5723 12.0379L16.0933 35.7059C16.0933 36.9059 16.7393 37.9459 17.6963 38.5249V42.4939H21.2933V38.4069C22.1443 37.8089 22.7033 36.8249 22.7033 35.7059L23.5873 21.4179L23.9643 18.6469L25.1383 35.7059C25.1383 36.9489 25.8323 38.0189 26.8473 38.5829V42.4939H30.4443V38.3189C31.2313 37.7149 31.7483 36.7749 31.7483 35.7059L32.4283 16.0379L32.1873 11.4229Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleeceSweatpant);
export default __webpack_public_path__ + "static/media/fleece_sweatpant.cbde064f616c45fe90d0809e77196651.svg";
export { ForwardRef as ReactComponent };